/**
 * Created by Tiger on 16/05/2022.
 */
import React, { useEffect } from 'react';
import { useRef } from 'react';

const useInterval = (callback: () => void, delay: number | null) => {
    const saveCallback = useRef(callback);
    useEffect(() => {
        saveCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setInterval(() => saveCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
};

export default useInterval;
